import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const evaluationRemainingMistakesConfig: Record<
  string,
  FormConfigProps
> = {
  //  dysgraphiaCountAsOne: {
  //    label: 'disgrafinių klaidų grupė skaičiuojama kaip viena klaida',
  //    value: 'dysgraphiaCountAsOne',
  //  },
  partialAnswersAccepted: {
    label:
      'neišsamus, nenuoseklus, bet iš esmės teisingas atsakymas vertinamas teigiamai',
    value: 'partialAnswersAccepted',
  },
  partialAgramaticAccepted: {
    label:
      'neišsamus, nenuoseklus, agramatiškas, bet iš esmės teisingas atsakymas vertinamas teigiamai',
    value: 'partialAgramaticAccepted',
  },
  scoreNotReducedForMaterials: {
    label: 'pasiekimų vertinimas nemažinamas dėl naudojimosi atramine medžiaga',
    value: 'scoreNotReducedForMaterials',
  },
  scoreNotReducedForDevices: {
    label:
      'pasiekimų vertinimas nemažinamas dėl naudojimosi specialiosiomis mokymo priemonėmis',
    value: 'scoreNotReducedForDevices',
  },
  scoreNotReducedForAudio: {
    label:
      'pasiekimų vertinimas nemažinamas dėl tekstų ir (ar) užduočių įgarsinimo',
    value: 'scoreNotReducedForAudio',
  },
  feedbackOnSuccessAndChallenges: {
    label:
      'teikiamas grįžtamasis ryšys, orientuotas į sėkmių ir sunkumų priežastis, jų įveikos būdus',
    value: 'feedbackOnSuccessAndChallenges',
  },
  individualProgressMonitoring: {
    label:
      'taikomas sistemingas individualios pažangos stebėjimas ir fiksavimas',
    value: 'individualProgressMonitoring',
  },
  progressMonitoringTeam: {
    label: 'individualios pažangos stebėjime dalyvauja:',
    value: 'progressMonitoringTeam',
    children: {
      teacherStudent: {
        label: 'mokytojas + mokinys',
        value: 'teacherStudent',
        paddingLeft: 24,
      },
      teacherStudentParents: {
        label: 'mokytojas + mokinys + tėvai (globėjai, rūpintojai)',
        value: 'teacherStudentParents',
        paddingLeft: 24,
      },
      fullSupportTeam: {
        label:
          'mokytojas + mokinys + tėvai (globėjai, rūpintojai) + švietimo pagalbos specialistai',
        value: 'fullSupportTeam',
        paddingLeft: 24,
      },
      progressMonitoringOther: {
        label: 'kita:',
        value: 'progressMonitoringOther',
        isInput: true,
        paddingLeft: 24,
      },
    },
  },
  other: {
    label: 'kita:',
    value: 'other',
    isInput: true,
  },
};

export const EvaluationRemainingMistakes = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={evaluationRemainingMistakesConfig}
      formPathParams={['subject', 'block5']}
      form={form}
    />
  );
};
